import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import { Heading, Paragraph } from '~elements'
import { Container } from 'react-grid-system'
import styles from './LostandFound.module.scss'
import { LostandFoundProps } from '~types'

const LostandFound = ({ description, headline, lostandfoundData = null }: LostandFoundProps) => {
  return (
    <Container className='container'>
      <div className={styles.lostandfound}>
        <div className={cx([styles.card, styles['col-wrapper--content']])}>
          {headline && <Heading level={1} levelDisplay='display-lg' justify='center'>{headline}</Heading>}
          {description && description?.html && (
            <div className={styles['description-container']}>
              <Paragraph text={description} fontSize={'md'} />
            </div>
          )}
        </div>
        {lostandfoundData && <div className={styles.content} dangerouslySetInnerHTML={{ __html: lostandfoundData }} />}
      </div>
    </Container>
  )
}

export default LostandFound
